module.exports = __webpack_public_path__ + "static/media/fye-main-body.c3b699b6.png";